import { Phone, MessageSquare } from "lucide-react";
import { PHONE_TEL, WHATSAPP_URL } from "../data/content";

export const FloatingButtons = () => {
  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-3.5 items-center">
      {/* Call Button */}
      <a
        href={PHONE_TEL}
        data-testid="floating-call-btn"
        aria-label="Call Spa Now"
        className="w-12 h-12 sm:w-14 sm:h-14 bg-gradient-to-r from-amber-400 via-amber-300 to-yellow-500 text-black rounded-full flex items-center justify-center shadow-[0_4px_20px_rgba(245,158,11,0.5)] hover:scale-110 active:scale-95 transition-all duration-300 group relative"
      >
        <Phone className="w-6 h-6 fill-black/20 text-black" />
        <span className="absolute right-16 bg-black/90 text-amber-300 text-xs font-bold px-3 py-1.5 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none border border-amber-400/30 shadow-lg">
          Call Branch Now
        </span>
      </a>

      {/* WhatsApp Button */}
      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp-btn"
        aria-label="Chat on WhatsApp"
        className="w-12 h-12 sm:w-14 sm:h-14 bg-[#25D366] text-white rounded-full flex items-center justify-center shadow-[0_4px_20px_rgba(37,211,102,0.5)] hover:scale-110 active:scale-95 transition-all duration-300 group relative"
      >
        <MessageSquare className="w-6 h-6 fill-white/20 text-white" />
        <span className="absolute right-16 bg-black/90 text-emerald-400 text-xs font-bold px-3 py-1.5 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none border border-emerald-400/30 shadow-lg">
          WhatsApp Desk
        </span>
      </a>
    </div>
  );
};
